import { permissions } from "@/constants";
import { LifecycleStageId } from "@/comp/pages/LifecyclePage/constants";

export enum StageTaskType {
    Text = 'text',
    Date = 'date',
    Boolean = 'boolean',
    Link = 'link',
    DateRange = 'dateRange',
    UserId = 'userId',
    Enum = 'enum',
    Units = 'units',
    Percentage = 'percentage',
    MeasurementUnit = 'measurementUnit'
}

export const OnlyControlledStages = [
    LifecycleStageId.Baseline,
    LifecycleStageId.ControlPrep
]
export const StagesAffectedTransitionsByControlType = [
    LifecycleStageId.Validation,
]

export const stageEditPermissionMap: {[key in LifecycleStageId]?: typeof permissions[keyof typeof permissions]} = {
    [LifecycleStageId.Opportunity]: permissions.MANAGE_OPPORTUNITY_STATION_STAGE,
    [LifecycleStageId.Design]: permissions.MANAGE_DESIGN_STATION_STAGE,
    [LifecycleStageId.Staging]: permissions.MANAGE_STAGING_STATION_STAGE,
    [LifecycleStageId.Installation]: permissions.MANAGE_INSTALLATION_STATION_STAGE,
    [LifecycleStageId.Validation]: permissions.MANAGE_VALIDATION_STATION_STAGE,
    [LifecycleStageId.Baseline]: permissions.MANAGE_BASELINE_STATION_STAGE,
    [LifecycleStageId.ControlPrep]: permissions.MANAGE_CONTROL_PREP_STATION_STAGE,
    [LifecycleStageId.New]: permissions.MANAGE_NEW_STATION_STAGE,
    [LifecycleStageId.OrderPlacement]: permissions.MANAGE_ORDER_PLACEMENT_STATION_STAGE
}

export enum StationControlType {
    Controlled = 'Controlled',
    NotControlled = 'NotControlled',
    NoFlowControl = 'NoFlowControl',
  }